export const AUDIO_LANGUAGE_MENU = 'AUDIO_LANGUAGE_MENU'
export const TOUR_LANGUAGE_MENU = 'TOUR_LANGUAGE_MENU'
export const VIDEO_QUALITY_MENU = 'VIDEO_QUALITY_MENU'
export const SHARE_MENU = 'SHARE_MENU'
export const OVERFLOW_MENU = 'OVERFLOW_MENU'
export const SET_CONTEXT_MENU = '|A|SET_CONTEXT_MENU'
export const HIDE_MENU = ''

export const setContextMenu = (type, contextMenu) => {
    return {
        type: SET_CONTEXT_MENU,
        contextMenu: Object.assign(
            {
                name: type,
            },
            contextMenu
        ),
    }
}

export const showAudioLanguageContextMenu = contextMenu => {
    return setContextMenu(AUDIO_LANGUAGE_MENU, contextMenu)
}

export const showTourLanguageContextMenu = contextMenu => {
    return setContextMenu(TOUR_LANGUAGE_MENU, contextMenu)
}

export const showVideoQualityContextMenu = contextMenu => {
    return setContextMenu(VIDEO_QUALITY_MENU, contextMenu)
}

export const showShareContextMenu = contextMenu => {
    return setContextMenu(SHARE_MENU, contextMenu)
}

export const showOverflowContextMenu = contextMenu => {
    return setContextMenu(OVERFLOW_MENU, contextMenu)
}

export const hideContextMenu = () => {
    return (dispatch, getState) => {
        const name = getState().getIn(['contextMenu', 'name'])

        if (name == HIDE_MENU) return

        dispatch(setContextMenu(HIDE_MENU))
    }
}
